module.exports = __webpack_public_path__ + "media/fonts/sovremennic/SovremennicCondensed-Light-1894268b15d235b458ac067db35dacd9.woff";